import React, { useState, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import BounceTransition from 'components/transition/bounce';
import SportsTypeIcon from 'components/sportsTypeIcon';
import OpacityTransition from 'components/transition/opacity';
import SportsLoader from 'components/sportsLoader';
import style from './style.module.scss';
import SoccerSimpleView from '../view/simple';
import { ReactComponent as MoreIcon } from 'images/sports/common/icon.svg';
import usePostMessage from 'hooks/UsePostMessage';
import useCommonStore from 'hooks/useCommonStore';
import { observer } from 'mobx-react';
import useStore from '../../../../hooks/useStore';
import { _SPORTS_TYPE } from '../../../../common/constants/sportsConstants';
import Banner from '../../../../components/banner';

const SoccerWrapper = observer(
  ({
    loading,
    list,
    finishedList,
    selectedGameList,
    selectedTab,
    selectedGames,
    setSelectedGame,
    scoreRef,
    resetParentFrame,
    nextDate,
    prevDate,
    onChangePage,
    currentDate,
    setCurrentDate,
    setSelectedTab,
    today,
    getTodayFinalSoccer,
  }) => {
    const [initList, setInitList] = useState(false);
    const [sportsSelected, setSportsSelected] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [defaultList, setDefaultList] = useState([]);
    const [finalList, setFinalList] = useState([]);
    const { postParentMessage } = usePostMessage();
    const { isAdminIP, openCaster } = useCommonStore();
    const { bannerStore } = useStore();

    useEffect(() => {
      if (!loading) {
        setSelectedList(selectedGameList);
        setDefaultList(list);
        setFinalList(finishedList);
        setSportsSelected(selectedGames);
        setInitList(true);
        bannerStore.clearActiveMajorView();
        bannerStore.setSportType(_SPORTS_TYPE.SOCCER);
      } else {
        setInitList(false);
      }
    }, [loading, list, finishedList, selectedGameList, selectedGames]);

    useEffect(() => {
      resetParentFrame(scoreRef.current.scrollHeight);
    });

    const emptyListText = useMemo(() => {
      if (selectedTab === 'ALL') {
        return '축구 경기 일정이 없습니다.';
      } else if (selectedTab === 'FAVORITE') {
        return '관심경기가 없습니다.';
      } else if (selectedTab === 'FINAL') {
        return '금일 종료 경기가 없습니다.';
      }
    }, [defaultList, selectedList, finishedList, selectedTab]);

    const changeDate = (date) => {
      setSelectedTab('ALL');
      setCurrentDate(date);
      onChangePage(date);
      postParentMessage({ method: 'scrollUp' });
    };

    const onClickCurrentFinal = () => {
      setSelectedTab('FINAL');
      getTodayFinalSoccer(today);
      postParentMessage({ method: 'scrollUp' });
    };

    return (
      <div
        className={style.soccer_score_board}
        style={{
          borderBottom: selectedTab === 'FAVORITE' ? '1px solid #dfe4ec' : 0,
        }}
      >
        <div className={style.sb_top}>
          <span className={clsx(style.cell, style.cell_league)}>리그명</span>
          <span className={clsx(style.cell, style.cell_date)}>시간</span>
          <span className={clsx(style.cell, style.cell_state)}>상태</span>
          <span className={clsx(style.cell, style.cell_team)}>홈팀</span>
          <span className={clsx(style.cell, style.cell_score)}>점수</span>
          <span className={clsx(style.cell, style.cell_team)}>원정팀</span>
          <span className={clsx(style.cell, style.cell_half)}>전반</span>
          <span className={clsx(style.cell, style.cell_exec)}>실행</span>
          <span className={clsx(style.cell, style.cell_favorites)}>관심</span>
        </div>
        {initList ? (
          selectedList.length > 0 || defaultList.length > 0 || finalList.length > 0 ? (
            <>
              {/* 관심경기 */}
              {selectedList.length > 0 && (
                <div className={style.headline}>
                  <span>관심경기</span>
                </div>
              )}
              {selectedList.map((item, idx) => {
                console.log('1');
                console.log(item);
                return (
                  <SoccerSimpleView
                    key={`soccer-selected-view-${item.id}`}
                    item={item}
                    isSelected={sportsSelected.some((id) => id.key === item.id)}
                    setSelectedGame={setSelectedGame}
                    isSelectedView={true}
                    isAdmin={isAdminIP}
                    openCaster={openCaster}
                  />
                );
              })}
              {/* 관심경기 */}

              {/* 기본 리스트 */}
              {defaultList.map((item, idx) => {
                console.log('2');
                console.log(item);
                return (
                  <SoccerSimpleView
                    key={`soccer-view-${item.id}`}
                    item={item}
                    isSelected={sportsSelected.some((id) => id.key === item.id)}
                    setSelectedGame={setSelectedGame}
                    isSelectedView={false}
                    isAdmin={isAdminIP}
                    openCaster={openCaster}
                  />
                );
              })}
              {today === currentDate && defaultList.length > 0 && (
                <button
                  className={clsx(style.headline, style.more, style.headlineBtn)}
                  onClick={() => changeDate(nextDate)}
                >
                  <MoreIcon />
                  <span>{nextDate} 일정 보기</span>
                </button>
              )}
              {/* 기본 리스트 */}

              {/* 종료 경기 */}
              {today === currentDate && selectedTab === 'ALL' && finalList.length > 0 && (
                <>
                  <div className={style.namedBackground} />
                  <div className={clsx(style.headline, style.final)}>
                    <span>경기결과</span>
                  </div>
                </>
              )}
              {finalList.map((item, idx) => {
                console.log('3');
                console.log(item);
                return (
                  <SoccerSimpleView
                    key={`soccer-view-${item.id}`}
                    item={item}
                    isSelected={sportsSelected.some((id) => id.key === item.id)}
                    setSelectedGame={setSelectedGame}
                    isSelectedView={false}
                    isAdmin={isAdminIP}
                    openCaster={openCaster}
                    isFinal
                  />
                );
              })}
              {selectedTab === 'ALL' && today === currentDate && finalList.length > 0 && (
                <div className={clsx(style.headline, style.more, style.finalHeadlineBtn)}>
                  <button onClick={() => changeDate(prevDate)}>
                    <MoreIcon />
                    <span>{prevDate} 결과 보기</span>
                  </button>
                  <button onClick={onClickCurrentFinal}>
                    <MoreIcon />
                    <span>{currentDate} 결과 보기</span>
                  </button>
                </div>
              )}
              {/* 종료 경기 */}
            </>
          ) : (
            <>
              <Banner paddingTop='10px' paddingBottom='0' />
              <div className={style.livescore_empty}>
                <BounceTransition loader={!loading} duration={200} type='bounce_in'>
                  <SportsTypeIcon sportsType={'SOCCER'} height={40} width={40} />
                </BounceTransition>
                <OpacityTransition loader={!loading} duration={200}>
                  <h3>{emptyListText}</h3>
                </OpacityTransition>
                <OpacityTransition loader={!loading} duration={200} delay={100}>
                  <h5>지난경기결과나 예정된 경기는 달력을 클릭하시면 편하게 찾아 보실 수 있습니다.</h5>
                </OpacityTransition>
              </div>
            </>
          )
        ) : (
          <SportsLoader />
        )}

        {/*// score_board  */}
      </div>
    );
  }
);

export default SoccerWrapper;
